import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const USVirginIslands: Country = {
    identifier: "USVirginIslands",
    name: "US Virgin Islands",
    countryCode: "VI",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇻🇮",
    svgPath: "m 292.90875,410.9164 -0.21,0.026 -0.291,-0.136 0.229,-0.052 0.148,0.033 0.124,0.129 z m 0.519,-0.071 -0.186,0.078 -0.125,-0.011 -0.048,-0.028 0.099,-0.091 0.26,0.052 z m -0.296,1.643 0.235,0.129 0.285,0 -0.297,0.129 -0.569,0.013 0.013,-0.207 0.333,-0.064 z",
}
